import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon4k: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-Icon4k"><Path d="M8.86523 12.8779H7.03418V12.8193L8.82617 9.83594H8.86523V12.8779Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM8.80664 14.3818V15.5H10.7598V14.3818H11.624V12.7949H10.7598V8.4541H7.89844L5.33984 12.7168V14.3818H8.80664ZM12.4102 8.4541V15.5H14.4805V13.6543L15.0322 12.9072L16.5703 15.5H18.9775L16.5508 11.5791L18.8701 8.4541H16.6973L14.5195 11.4424H14.4805V8.4541H12.4102Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon4k;
